const PATTERNS = [
  // comma
  {
    unescaped: [/,/g, '(COMMA)', ','], // [escapePattern, temporary replacement, final replacement]
    escaped: [/\\,/g, '(COMMA)', '\\,'] // [escapePattern, temporary replacement, final replacement]
  }
] as const;

type SafeString = `${string}${'(COMMA)' | ''}${string}`;
type EscapedString = `${string}${'\\,' | ''}${string}`;
type UnEscapedString = `${string}${',' | ''}${string}`;

// for case when value === 'a1\\,a2'
export const stringUtil = {
  escapedToSafe(value: EscapedString | undefined): SafeString | UnEscapedString | undefined {
    if (!value || value === ' ') {
      return undefined;
    }
    return PATTERNS.reduce((acc, item) => {
      const [pattern, replacement] = item.escaped;
      return acc.replaceAll(pattern, replacement);
    }, value) as SafeString;
  },
  unEscapedToSafe: (value: UnEscapedString | undefined): SafeString | undefined => {
    if (!value || value === ' ') {
      return undefined;
    }
    return PATTERNS.reduce((acc, item) => {
      const [pattern, replacement] = item.unescaped;
      return acc.replaceAll(pattern, replacement);
    }, value) as SafeString;
  },
  safeToUnescaped: (value: SafeString | undefined): UnEscapedString | undefined => {
    if (!value || value === ' ') {
      return undefined;
    }
    return PATTERNS.reduce((acc, item) => {
      const [_, tempReplacement, finalReplacement] = item.unescaped;
      return acc.replaceAll(tempReplacement, finalReplacement);
    }, value);
  },
  safeToEscaped(value: SafeString | undefined): EscapedString | undefined {
    if (!value || value === ' ') {
      return undefined;
    }
    return PATTERNS.reduce((acc, item) => {
      const [_, tempReplacement, finalReplacement] = item.escaped;
      return acc.replaceAll(tempReplacement, finalReplacement);
    }, value);
  },
  unEscapedToEscaped(value: UnEscapedString): EscapedString {
    return PATTERNS.reduce((acc, item) => {
      const [pattern] = item.unescaped;
      const [_, __, finalReplacement] = item.escaped;
      return acc.replaceAll(pattern, finalReplacement);
    }, value);
  }
};
